import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { motion } from 'framer-motion';
import MotionVisible from 'src/components/MotionVisible';
import TitleEffect from 'src/components/TitleEffect';
import tokenmetricMb from 'src/assets/images/onepaper/tokenmetricMb.png';
import iconCopy from 'src/assets/images/copyOutlined.svg';
import lineArrow from 'src/assets/images/onepaper/lineArrowSm.svg';
import { caloAddress } from 'src/variables/calo';
import { animationVariant } from 'src/variables/animationVariant';
import { StyledTokenMetricsMobile } from './styled';
import { truncateAddress } from 'src/utils/text';

const TokenMetricsMobile = () => {
  const [copied, setCopied] = useState(false);

  const copyAddress = (address) => {
    setCopied(true);
    if (navigator.clipboard && navigator.permissions) {
      navigator.clipboard.writeText(address);
    } else if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('input');
      ele.value = address;
      document.body.appendChild(ele);
      ele.select();
      document.execCommand('copy');
      document.body.removeChild(ele);
    }
  };

  return (
    <StyledTokenMetricsMobile>
      <div className="container">
        <MotionVisible className="header" variants={animationVariant}>
          <TitleEffect className="t-1" text="TOKEN METRIC" fontSize="48px" />
          <img className="text-center img-fluid" src={lineArrow} alt="line" />
        </MotionVisible>
        <MotionVisible className="token-desc" variants={animationVariant}>
          <div className="desc">
            Calo Token is minted at the Token Generation Event (TGE) with the
            total number of 500,000,000 minted Tokens.
          </div>
          <div className="contract-box flex-between">
            <div className="label">
              Contract address:
              <span className="address">
                {truncateAddress(caloAddress, 12)}
              </span>
            </div>
            <Tooltip
              title={copied ? 'Copied' : 'Copy'}
              onVisibleChange={(visible) => {
                if (!visible) {
                  setCopied(false);
                }
              }}
            >
              <img
                className="icon-copy"
                src={iconCopy}
                onClick={() => copyAddress(caloAddress)}
              />
            </Tooltip>
          </div>
        </MotionVisible>
        <MotionVisible
          className="box-img text-center"
          variants={animationVariant}
        >
          <img className="img-fluid" src={tokenmetricMb} />
        </MotionVisible>
      </div>
    </StyledTokenMetricsMobile>
  );
};

export default TokenMetricsMobile;
